import type { ResourceCategory } from '@/data/resources';
import type { ResourcePostCategoryApi } from '@/types/api/resource-post';

const UI_TO_API: Record<Exclude<ResourceCategory, 'all'>, ResourcePostCategoryApi> = {
	productInfo: 'PRODUCT_INFO',
	guide: 'USER_GUIDE',
	education: 'EDUCATION',
	simulationRoom: 'SIMULATION',
};

const API_TO_UI: Record<ResourcePostCategoryApi, Exclude<ResourceCategory, 'all'>> = {
	PRODUCT_INFO: 'productInfo',
	USER_GUIDE: 'guide',
	EDUCATION: 'education',
	SIMULATION: 'simulationRoom',
};

export function resourceCategoryUiToApi(
	c: Exclude<ResourceCategory, 'all'>
): ResourcePostCategoryApi {
	return UI_TO_API[c] ?? 'USER_GUIDE';
}

export function resourceCategoryApiToUi(
	c: string
): Exclude<ResourceCategory, 'all'> {
	return API_TO_UI[c as ResourcePostCategoryApi] ?? 'guide';
}
